<template>
	<vue-event-form :limitedCapability="hasSubscriber"></vue-event-form>
</template>

<script>
import VueEventForm from './Form.vue'
export default {
	components: {
		VueEventForm,
	},
	data() {
		return {
			hasSubscriber: false,
		}
	},
	mounted() {
		this.hasSubscriber = parseInt( $('#has_subscriber').val() );
		this.hasSubscriber = !!this.hasSubscriber;
	},
}
</script>
